import type { CreatorSearchLimitNudgeViewModel } from '@/entities/workspace/util/creator-search-limit-ux';
import { OverlayBanner } from '@/shared/components/overlay-banner';
import { Button } from '@/shared/components/shadcn/button';
import { CreatorCardSkeleton } from '../creator-card/creator-card.skeleton';

interface Props {
  viewModel: CreatorSearchLimitNudgeViewModel;
  onCtaClick: () => void;
}

export function CreatorsResultsEndState({ viewModel, onCtaClick }: Props) {
  return (
    <section className="relative">
      <div aria-hidden="true" className="relative h-180">
        <div className="absolute z-30 w-full">
          <CreatorCardSkeleton />
        </div>
        <div className="absolute z-20 w-full translate-y-12 scale-95">
          <CreatorCardSkeleton />
        </div>
        <div className="absolute z-10 w-full translate-y-20 scale-90">
          <CreatorCardSkeleton />
        </div>
      </div>

      <OverlayBanner
        title={viewModel.title}
        description={
          <>
            {viewModel.body}
            <br />
            {viewModel.supportingBody}
          </>
        }
        action={
          <Button
            size="sm"
            variant={viewModel.action.buttonVariant}
            className="w-full shrink-0 sm:w-auto"
            onClick={onCtaClick}
          >
            {viewModel.action.label}
          </Button>
        }
        className="inset-x-4 top-60 z-50 -translate-y-1/2 sm:inset-x-8"
      />
    </section>
  );
}
